import { SaveAlt, Search } from "@material-ui/icons";
import { Box, Fab, Grid, Tooltip } from "@mui/material";
import DateRangePicker from "components/date-picker/DateRangePicker";
import Select from "components/select/Select";
import { ALL_OPTION, LIST_GROUP_LEVEL, TYPE_PBX_OPTIONS } from "constant";
import { useFormik } from "formik";
import { useCityDistrictProvince } from "hooks/select/useCityDistrictProvince";
import { useMemo } from "react";
import { getDateRangePickerFieldProps, getSelectFieldProps } from "ultis/form";

const ReportOutboundCallByUnitFilter = ({
  onSubmit,
  onExport,
  isDisabledExport,
}) => {
  const defaultFrom = new Date();
  defaultFrom.setHours(0, 0, 0, 0);
  const defaultTo = new Date(defaultFrom);
  defaultTo.setHours(23, 59, 59, 999);
  const formik = useFormik({
    initialValues: {
      cityCode: ALL_OPTION.value,
      district: ALL_OPTION.value,
      subOrg: ALL_OPTION.value,
      typePbx: ALL_OPTION.value,
      groupBy: LIST_GROUP_LEVEL[0].value,
      dateRange: [defaultFrom, defaultTo],
    },
    onSubmit,
  });

  const formValues = formik.values;

  const {
    listCityPostOfficeOptions,
    listDistrictPostOfficeOptions,
    listProvinceOptions,
  } = useCityDistrictProvince({
    citycode: formValues?.cityCode,
    districtcode: formValues?.district,
  });

  function sortArrayByCode(array) {
    if (!array) return [];
    return array.sort((a, b) => {
      return parseInt(a.value) - parseInt(b.value);
    });
  }
  const sortedData = useMemo(
    () => sortArrayByCode(listCityPostOfficeOptions),
    [listCityPostOfficeOptions]
  );
  return (
    <form onSubmit={formik.handleSubmit}>
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Select
              label="Bưu điện tỉnh/thành phố"
              {...getSelectFieldProps(formik, "cityCode")}
              onChange={async (newValue) => {
                await formik.setFieldValue("cityCode", newValue);
                await formik.setFieldValue("district", ALL_OPTION.value);
                await formik.setFieldValue("postoffice", ALL_OPTION.value);
              }}
              options={sortedData}
              showAllOption
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              label="Bưu điện huyện"
              {...getSelectFieldProps(formik, "district")}
              onChange={async (newValue) => {
                await formik.setFieldValue("district", newValue);
                await formik.setFieldValue("postoffice", ALL_OPTION.value);
              }}
              options={listDistrictPostOfficeOptions}
              showAllOption
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              label="Bưu cục"
              {...getSelectFieldProps(formik, "subOrg")}
              options={listProvinceOptions}
              showAllOption
            />
          </Grid>

          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "typePbx")}
              onChange={(newContactCode) => {
                formik.setFieldValue("typePbx", newContactCode);
              }}
              label="Loại tổng đài"
              options={TYPE_PBX_OPTIONS}
              showAllOption
            />
          </Grid>
          <Grid item xs={3}>
            <Select
              {...getSelectFieldProps(formik, "groupBy")}
              onChange={(newGroupBy) => {
                formik.setFieldValue("groupBy", newGroupBy);
              }}
              label="Nhóm theo cấp"
              options={LIST_GROUP_LEVEL}
            />
          </Grid>

          <Grid item xs={6}>
            <DateRangePicker
              {...getDateRangePickerFieldProps(formik, "dateRange")}
              isTime
              startDateLabel="Thời gian gọi từ"
              endDateLabel="Thời gian gọi đến"
            />
          </Grid>

          <Grid item xs={3}>
            <Tooltip title="Tìm kiếm" disableFocusListener>
              <Fab color="primary" aria-label="Search" type="submit">
                <Search />
              </Fab>
            </Tooltip>
            <Tooltip title="Tải báo cáo" disableFocusListener>
              <Fab
                color="primary"
                sx={{ ml: 1 }}
                aria-label="Search"
                onClick={onExport}
                disabled={isDisabledExport}>
                <SaveAlt />
              </Fab>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export default ReportOutboundCallByUnitFilter;
